"use client";
import { Controller } from "react-hook-form";
import React from "react";
import { WcNumber, WcNumberProps } from "@bpipartners/webui";

type WcNumberControllerProps = WcNumberProps & {
  name: string;
  control: any;
  max?: number;
  min?: number;
};

export const WcNumberController = ({ name, control, max, min, disabled, ...props }: WcNumberControllerProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value, onBlur }, fieldState: { error }, formState }) => (
      <WcNumber
        helperText={error ? error.message : null}
        error={!!error}
        disabled={disabled}
        onValue={(event: any) => {
          if (min !== undefined && min !== null && max !== undefined && max !== null) {
            if (event <= max && event >= min) {
              value = event;
              onChange(event);
            } else {
              if (event > max) {
                value = max;
                onChange(max);
              } else {
                value = min;
                onChange(min);
              }
            }
          } else {
            value = event;
            onChange(event);
          }
        }}
        value={value}
        {...props}
      />
    )}
  />
);
